import { useI18n } from '../../i18n';
import { arcPath } from './geometry';

/**
 * The North Indian diamond, annotated for the Learn course: the twelve fixed
 * bhava compartments numbered in place, the lagna marked in bhava 1, and an
 * arrow showing that the count runs anticlockwise. Same geometry as the real
 * NorthIndianChart, minus the chart data.
 */

/** Compartment label anchors for the 300×300 square, bhavas 1..12. */
const BHAVA_POS: [number, number][] = [
  [150, 92], // 1
  [72, 40], // 2
  [40, 78], // 3
  [92, 150], // 4
  [40, 222], // 5
  [72, 260], // 6
  [150, 208], // 7
  [228, 260], // 8
  [260, 222], // 9
  [208, 150], // 10
  [260, 78], // 11
  [228, 40], // 12
];

export function NorthLayout() {
  const { t } = useI18n();
  return (
    <svg
      viewBox="0 0 300 324"
      style={{ width: '100%', height: 'auto' }}
      role="img"
      aria-label={t('learn.fig.northLayout.alt')}
    >
      <defs>
        <marker
          id="north-anticlockwise"
          viewBox="0 0 8 8"
          refX="6"
          refY="4"
          markerWidth="7"
          markerHeight="7"
          orient="auto"
        >
          <path d="M 0 0 L 8 4 L 0 8 Z" fill="var(--mode-ink)" />
        </marker>
      </defs>

      {/* Bhava 1 shaded: the compartment the whole count hangs from. */}
      <path d="M 150 2 L 224 76 L 150 150 L 76 76 Z" fill="var(--mode-soft)" stroke="none" />

      <rect
        x="2"
        y="2"
        width="296"
        height="296"
        fill="none"
        stroke="var(--border-strong)"
        strokeWidth="1.5"
        rx="6"
      />
      <line x1="2" y1="2" x2="298" y2="298" stroke="var(--border-strong)" strokeWidth="1" />
      <line x1="298" y1="2" x2="2" y2="298" stroke="var(--border-strong)" strokeWidth="1" />
      <path
        d="M 150 2 L 298 150 L 150 298 L 2 150 Z"
        fill="none"
        stroke="var(--border-strong)"
        strokeWidth="1"
      />

      {BHAVA_POS.map(([x, y], i) => (
        <text
          key={i}
          x={x}
          y={y + 4}
          textAnchor="middle"
          fontSize="13"
          fontWeight="700"
          fill={i === 0 ? 'var(--mode-ink)' : 'var(--text)'}
        >
          {i + 1}
        </text>
      ))}
      <text
        x={150}
        y={66}
        textAnchor="middle"
        fontSize="9.5"
        fontWeight="600"
        fill="var(--mode-ink)"
      >
        {t('learn.fig.lagna')}
      </text>

      {/* 1 → 2 → 3: the count leaves bhava 1 anticlockwise. */}
      <path
        d={arcPath(150, 150, 46, -20, -70, 0)}
        fill="none"
        stroke="var(--mode-ink)"
        strokeWidth="1.5"
        markerEnd="url(#north-anticlockwise)"
      />

      <text x={150} y={316} textAnchor="middle" fontSize="10" fill="var(--text-dim)">
        {t('learn.fig.northLayout.note')}
      </text>
    </svg>
  );
}
